import { axiosGlobalPayInstance, handleResponse, handleError } from './index';

export async function createDraftTransaction(reqBody) {
  try {
    const response = await axiosGlobalPayInstance.post('/draft', reqBody);

    return handleResponse(response);
  } catch (err) {
    return handleError(err);
  }
}

export async function createTerminalSale(reqBody) {
  try {
    const response = await axiosGlobalPayInstance.post(
      '/transactions/createTerminalSale',
      reqBody
    );

    return handleResponse(response);
  } catch (err) {
    return handleError(err);
  }
}

export async function createPayFieldsSale(reqBody) {
  try {
    const response = await axiosGlobalPayInstance.post(
      '/transactions/createPayFieldsSale',
      reqBody
    );

    return handleResponse(response);
  } catch (err) {
    return handleError(err);
  }
}

export async function createSavedCardSale(reqBody) {
  try {
    const response = await axiosGlobalPayInstance.post(
      '/transactions/createSavedCardSale',
      reqBody
    );

    return handleResponse(response);
  } catch (err) {
    return handleError(err);
  }
}

export async function cancelTerminalSale(transactionId) {
  try {
    const response = await axiosGlobalPayInstance.put(
      '/transactions/cancelTerminalSale',
      { transactionId }
    );

    return handleResponse(response);
  } catch (err) {
    return handleError(err);
  }
}

export async function runCNPZeroDollarAuth(tempToken, billingAddress) {
  try {
    const response = await axiosGlobalPayInstance.post(
      '/transactions/runCNPZeroDollarAuth',
      { tempToken, billingAddress }
    );

    return handleResponse(response);
  } catch (err) {
    return handleError(err);
  }
}

export async function runTerminalZeroDollarAuth(deviceId, transactionId) {
  try {
    const response = await axiosGlobalPayInstance.post(
      '/transactions/runTerminalZeroDollarAuth',
      { deviceId, transactionId }
    );

    return handleResponse(response);
  } catch (err) {
    return handleError(err);
  }
}

export async function deleteCardTokens(cardTokens) {
  try {
    // has to be post to have the body
    const response = await axiosGlobalPayInstance.post(
      '/cards/deleteCardTokens',
      { cardTokens }
    );

    return handleResponse(response);
  } catch (err) {
    return handleError(err);
  }
}

export async function processVoid(transactionId, voidReason) {
  try {
    const response = await axiosGlobalPayInstance.post('/transactions/void', {
      transactionId,
      voidReason,
    });

    return handleResponse(response);
  } catch (err) {
    return handleError(err);
  }
}
